"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var ScreenSharingMessageFlag;
(function (ScreenSharingMessageFlag) {
    ScreenSharingMessageFlag[ScreenSharingMessageFlag["Broadcast"] = 0] = "Broadcast";
    ScreenSharingMessageFlag[ScreenSharingMessageFlag["Local"] = 1] = "Local";
    ScreenSharingMessageFlag[ScreenSharingMessageFlag["Synthesized"] = 2] = "Synthesized";
    ScreenSharingMessageFlag[ScreenSharingMessageFlag["Unicast"] = 3] = "Unicast";
})(ScreenSharingMessageFlag = exports.ScreenSharingMessageFlag || (exports.ScreenSharingMessageFlag = {}));
exports.default = ScreenSharingMessageFlag;
//# sourceMappingURL=ScreenSharingMessageFlag.js.map